let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d2B7v")).then(() => parcelRequire('eUVKq'));